export const createReportDataKey = (params) => {
  const { type, filter, limit, order, view, } = params;
  let key = type; // type should be specified in params.
  if(filter) key += '_' + filter;
  if(limit) key += '_' + limit;
  if(order) key += '_' + order;
  if(view) key += '_' + view;
  return key;
};